import React from 'react';
import PropTypes from "prop-types"
import {Helmet} from 'react-helmet';


const SEO = ({ title,date,authorName,tags,description,image,location}) => {

	const isHome = location.pathname === '/';


let blogSchema = { 
	"@context": "https://schema.org", 
 	"@type": "Article",
 	"headline": title,
 	"image": image,
 	"author": {
 	  "@type":"Person",
 	  "url":location.href,
 	  "name":authorName, 
 	},
 	"keywords": tags, 
	"publisher": {
    	"@type": "Organization",
    	"name": location.hostname,
    	"logo": {
      		"@type": "ImageObject",
      		"url": ""
    	}
  	},
 	"url": location.href,
 	"datePublished": date,
 	"description": description,
 };
   

let siteSchema = {
	"@context": "http://schema.org",
  "@type": "WebPage",
  "name": authorName ,
  "description": location,
  "publisher": {
    "@type": "ProfilePage",
    "name": title
  }
};

 const metaTags = [
    { itemprop: 'name', content: 'summary' },
    { itemprop: 'description', content: 'description'},
    { itemprop: 'image', content: image },
    { name: 'description', content: description},
    
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:site', content: title},
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description},
    {
      name: 'twitter:image',
      content: image,
    },
    
    
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: title},
    { property: 'og:url', content: location.href},
    { property: 'og:image', content: image },
    { property: 'og:description', content: description},
    { property: 'og:site_name', content: location.host},
  ];
  
  return (
  <Helmet
  	title={title}
  	meta={metaTags}
  >

      
  <script type="application/ld+json">
  {JSON.stringify(isHome ? siteSchema:blogSchema)}
  </script>
 
      
      
    </Helmet>
  
  
  
   
)
};

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  authorName: PropTypes.string,
  tags: PropTypes.array,
  description: PropTypes.string,
  image: PropTypes.string,
  location: PropTypes.object
};

export default SEO;
